// extracted by mini-css-extract-plugin
export default {"about":"HomeInfo_about__5v8Om","link_image":"HomeInfo_link_image__IVdZf","big_image":"HomeInfo_big_image__wmqPx","profile":"HomeInfo_profile__0M-lZ","info":"HomeInfo_info__wmnFH"};